import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import ClientsTable from './ClientsTable';
import { Container as LayoutContainer, PageHeader, Tabs } from '../layout';
import styles from './AdminDashboard.module.css';

const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState('chat');

    return (
        <div className="clients">
            <LayoutContainer fluid>
                <Row className="align-items-center">
                    <Col>
                        <PageHeader title="Clients" subtext="View and manage all your Clients"/>
                    </Col>
                    {/* <Col className="d-flex justify-content-end">
                        <Button iconLeft={{ name: 'user_actions/diamond' }} textColor="var(--brand-as-neutral-black-950)" color="var(--brand-as-neutral-black-transparent-05)" text="Button" >
                            <b>Beep.</b> <span>&nbsp;</span> Need any help with your Canvasses?
                        </Button>
                    </Col> */}
                </Row>
                <ClientsTable />
            </LayoutContainer>
        </div>
    );
};

export default AdminDashboard;